import styled from 'styled-components'
import Checkboxes from 'components/Form/Checkboxlevel'
import { Checkbox } from 'antd'
import Flex from 'components/Flex'

export const StyledGroup = styled(Checkbox.Group)`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  .ant-checkbox-disabled .ant-checkbox-inner {
    background-color: #3249d7;
    border-color: #3249d7 !important;
  }

  .ant-checkbox-disabled .ant-checkbox-inner {
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 20px;
  }

  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: #fff;
    animation-name: none;
  }
  .ant-checkbox-inner {
    height: 18px;
    width: 18px;
    border-radius: 5px;
    border: 2px solid #cccfd6; /* Black border for enabled (not checked) checkboxes */
  }

  .ant-checkbox-input:checked + .ant-checkbox-inner {
    border: none;
  }

  .ant-checkbox:hover .ant-checkbox-inner {
    border: 2px solid #cccfd6; /* Replace 'your-hover-color' with the desired color value */
  }
`
export const StyledCheckbox = styled(Checkboxes)``
export const StyledCheckbox1 = styled(Checkboxes)`
  font-size: 12px !important;
  margin-left: 0 !important;
  padding: 10px !important;
`
export const StyledOutline = styled(Flex)`
  padding: 10px;
  margin: 10px;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
`
export const OuterDiv = styled.div`
  // margin: 10px 12px;
  padding: 1px;
  // padding-left: 12px;
`
